"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

var _typeGuards = require("../../../libs/typeGuards");

var _inputUnit = require("../input-unit");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TextArea = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(TextArea, _PureComponent);

  var _super = _createSuper(TextArea);

  function TextArea() {
    var _this;

    (0, _classCallCheck2.default)(this, TextArea);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "textareaElement", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "adjustHeight", function () {
      var value = _this.props.value;

      if (!_this.props.adjustHeight || _this.textareaElement === null) {
        return;
      }

      var el = _this.textareaElement;
      var outerHeight = parseInt(window.getComputedStyle(el).height, 10);
      var diff = outerHeight - el.clientHeight;
      el.style.height = value ? String(el.scrollHeight + diff) + 'px' : 'auto';
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onInputChange", function (event) {
      var onInputChange = _this.props.onInputChange;
      var value = event.target.value;
      onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange(value);

      _this.adjustHeight();
    });
    return _this;
  }

  (0, _createClass2.default)(TextArea, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.adjustHeight) {
        this.adjustHeight();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          onContentChange = _this$props.onContentChange,
          onTextareaFocus = _this$props.onTextareaFocus,
          disabled = _this$props.disabled,
          isControl = _this$props.isControl,
          maxLength = _this$props.maxLength,
          placeholder = _this$props.placeholder,
          value = _this$props.value,
          verticalResize = _this$props.verticalResize,
          size = _this$props.size,
          rows = _this$props.rows,
          required = _this$props.required;
      var className = "a-text-area a-text-area--app-".concat(isControl ? 'control' : 'destination');
      if (verticalResize) className += ' a-text-area--vertical-resize';
      if (size) className += " a-text-area--size-".concat(size);
      return (0, _preact.h)(_inputUnit.LabelId.Consumer, null, function (labelId) {
        return (0, _preact.h)(_inputUnit.ValidationErrorId.Consumer, null, function (validationErrorId) {
          return (0, _preact.h)("textarea", {
            "aria-describedby": validationErrorId !== null && validationErrorId !== void 0 ? validationErrorId : undefined,
            "aria-invalid": !!validationErrorId,
            className: className,
            disabled: disabled,
            id: labelId,
            maxLength: maxLength,
            onChange: function onChange(e) {
              return onContentChange && (0, _typeGuards.hasValueInEventTarget)(e) && onContentChange(e.target.value);
            },
            onClick: onTextareaFocus,
            onInput: _this2.onInputChange,
            placeholder: placeholder,
            ref: function ref(textarea) {
              _this2.textareaElement = textarea;
            },
            value: value,
            rows: rows,
            required: required
          });
        });
      });
    }
  }]);
  return TextArea;
}(_preactCompat.PureComponent);

var _default = TextArea;
exports.default = _default;